import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Layout from "../../layout/Layout";
import ThemeForm from "./ThemeForm";
import FormSkeleton from "../../Component/theme-management/FormSkeleton";
import { themesApi, isAuthError } from "../../helpers/tmClient";

/** Edit Theme page — loads the theme, then renders the reusable form. */
const ThemeEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [theme, setTheme] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await themesApi.detail(id);
        if (isAuthError(res)) return navigate("/");
        if (res.data.status && res.data.data?.theme) {
          setTheme(res.data.data.theme);
        } else {
          toast.error("Theme not found", { position: "bottom-right", autoClose: 1000 });
          navigate("/themes");
        }
      } catch {
        toast.error("Failed to load theme", { position: "bottom-right", autoClose: 1000 });
        navigate("/themes");
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (loading) {
    return (
      <Layout sidebar={true}>
        <div className="page-heading"><h3 className="my-1">Edit Theme</h3></div>
        <div className="page-content">
          <FormSkeleton fields={3} images={4} />
        </div>
      </Layout>
    );
  }
  return theme ? <ThemeForm mode="edit" initial={theme} /> : null;
};

export default ThemeEdit;
